import { ChangeEvent, useState } from 'react';
import CloseButton from '@common/closeButton';
import Text from '@common/text';
import Button from '@common/button';

import Checkbox from '@common/checkbox';
import Icon from '@components/common/assets';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useUsersWorkLogCounts } from '@repository/users/useUsers';
import Colors from '@domain/constant/colors';
import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface Step2Props {
  onClose: () => void;
  onConfirm: () => void;
}

const Index = ({ onClose, onConfirm }: Step2Props) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const { data: userInfo } = useUserInfo();
  const { data: workLogData } = useUsersWorkLogCounts();
  const userName = userInfo?.name || '회원';

  const accApplyCount = workLogData?.accApplyCount || 0;
  const jobApplicationCount = workLogData?.jobApplicationCount || 0;
  const matchStatusCount = workLogData?.matchStatusCount || 0;
  const profileCompletionRate = workLogData?.profileCompletionRate || 0;
  const isEmpty =
    accApplyCount === 0 && jobApplicationCount === 0 && matchStatusCount === 0 && profileCompletionRate === 0;

  const handleClick = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className={cx('modalArea')}>
      <div className={cx('textArea')}>
        <Text fontStyle={FontStyle.H4_B} color={Colors.C_JOBDA_BLACK}>
          {userName}님의
          <br />
          <Text element={'span'} fontStyle={FontStyle.H4_B} color={Colors.C_GREEN_200}>
            소중한 기록
          </Text>
          이 완전히 사라져요.
        </Text>
      </div>

      {!isEmpty && (
        <ul className={cx('listArea')}>
          {accApplyCount > 0 && (
            <li className={cx('listItem')}>
              <Icon name="acca" width={48} height={48} />
              <div className={cx('listText')}>
                <Text fontStyle={FontStyle.B2_B} color={Colors.C_COOL_GRAY_90}>
                  역량검사 응시 이력 {accApplyCount}개가 삭제됩니다.
                </Text>
                <Text fontStyle={FontStyle.B4_M} color={Colors.C_COOL_GRAY_70}>
                  (단, 본인인증 정보 및 역량검사 응시 횟수는 90일 보관 후 삭제)
                </Text>
              </div>
            </li>
          )}
          {jobApplicationCount > 0 && (
            <li className={cx('listItem')}>
              <Icon name="matchingPersonGreen" width={48} height={48} />
              <Text fontStyle={FontStyle.B2_B} color={Colors.C_COOL_GRAY_90}>
                나의 지원 이력 {jobApplicationCount}개가 삭제됩니다.
              </Text>
            </li>
          )}
          {matchStatusCount > 0 && (
            <li className={cx('listItem')}>
              <Icon name="invitationUser" width={48} height={48} />
              <Text fontStyle={FontStyle.B2_B} color={Colors.C_COOL_GRAY_90}>
                나에게 온 열람, 관심, 채용 제안 알림 {matchStatusCount}개가 삭제됩니다.
              </Text>
            </li>
          )}
          {profileCompletionRate > 0 && (
            <li className={cx('listItem')}>
              <Icon name="resumeDoneGreen" width={48} height={48} />
              <Text fontStyle={FontStyle.B2_B} color={Colors.C_COOL_GRAY_90}>
                내 프로필 작성 항목 {profileCompletionRate}개가 삭제됩니다.
              </Text>
            </li>
          )}
        </ul>
      )}

      <div className={cx('descArea')}>
        <div className={cx('descWrap')}>
          <Icon name="checkLight" width={24} height={24} />
          <div>
            <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_90}>
              서비스 부정 참여 방지를 위해 본인인증 정보 및 역량검사 응시 횟수는 90일간 보관돼요.
            </Text>
            <Text fontStyle={FontStyle.B3P_B} color={Colors.C_COOL_GRAY_90}>
              따라서 90일 안에 재가입하실 경우, 계정 삭제 이전의 역량검사 응시 횟수가 유지돼요.
            </Text>
          </div>
        </div>

        <div className={cx('descWrap')}>
          <Icon name="checkLight" width={24} height={24} />
          <div>
            <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_90}>
              그 외의 모든 회원 정보 및 활동 정보(역량검사 결과, 내 프로필, 지원 이력 등)는 완전히 삭제되며
            </Text>
            <Text fontStyle={FontStyle.B3P_M} color={Colors.C_COOL_GRAY_90}>
              복구될 수 없어요.
            </Text>
          </div>
        </div>
      </div>

      <label className={cx('checkBoxArea')}>
        <Checkbox
          onChange={(e: ChangeEvent<HTMLInputElement>) => setIsDisabled(!e.target.checked)}
          margin="0 8px 0 0"
        />
        <Text fontStyle={FontStyle.B2_M} color={Colors.C_COOL_GRAY_70}>
          안내 사항을 모두 확인했으며, 계정 및 데이터를 완전히 삭제할게요.
        </Text>
      </label>

      <Button className={cx('btnConfirm')} disabled={isDisabled} onClick={handleClick}>
        계정 삭제하기
      </Button>

      <CloseButton className={cx('btnClose')} onClick={onClose} />
    </div>
  );
};

export default Index;
